import { getSessionLinks } from '~/selectors/session-details'
import { FUNCTIONS } from '~/core/constants'
import store from '~/core/store'
import { getSessionSharedFilesAsArray, selectHasMorePages } from '~/selectors/shared-files'
import { getSharedFiles } from '~/actions/shared-files'
import { getIsElectron, getIsMobileSummaryPage } from '~/selectors/app'
import { downloadFile, isIOSWebView, shareWebViewBlob } from '~/core/utils'
import { showErrorNotification } from '~/core/ui'
import { translate } from '~/core/translate'

const getBlob = async (url) => {
  const resp = await fetch(url)
  const respBlob = await resp.blob()

  return new Blob([respBlob])
}

export const RESOURCE_TYPES = {
  LINK: 'LINK',
  FILE: 'FILE'
}

export const RESOURCE_TYPE_MAPPINGS = {
  [RESOURCE_TYPES.LINK]: {
    itemsSelector: getSessionLinks,
    fetchMoreItemsAction: FUNCTIONS.NOOP,
    hasMoreSelector: FUNCTIONS.NULL,
    linkClickedCallback: url => {
      window.open(url, '_blank')
    },
    titleTranslateKey: 'meeting_links_title',
    sharedByTranslateKey: 'shared_by'
  },
  [RESOURCE_TYPES.FILE]: {
    itemsSelector: getSessionSharedFilesAsArray,
    fetchMoreItemsAction: getSharedFiles,
    hasMoreSelector: selectHasMorePages,
    linkClickedCallback: async (url, fileName) => {
      const isElectron = getIsElectron(store.getState())
      const isMobileSummary = getIsMobileSummaryPage(store.getState())

      try {
        const blob = await getBlob(url)
        if (isMobileSummary && isIOSWebView()) {
          shareWebViewBlob(blob, fileName)
        } else {
          const downloadUrl = URL.createObjectURL(blob)
          downloadFile({ url: downloadUrl, isElectron, fileName })
          URL.revokeObjectURL(downloadUrl)
        }
      } catch {
        showErrorNotification(translate('error_fetching_shared_file'))
      }
    },
    titleTranslateKey: 'meeting_files_title',
    sharedByTranslateKey: 'file_shared_by'
  }
}
